<template>
<div>
    <nav class="mx-4 border-b border-gray-dark md:flex md:justify-between md:items-end">
        <h2 class="md:w-1/4 font-bold text-xl px-4 py-4">Team</h2>
        <nav class="md:w-2/4 md:text-center uppercase text-xs pb-4">
            <a href="#defaults" @click.prevent="onNav('defaults')" class="p-4" :class="hasNav('defaults') ? 'border-primary border-b-2 font-bold text-primary' : ''">Defaults</a>
            <a href="#settings" @click.prevent="onNav('settings')" class="p-4" :class="hasNav('settings') ? 'border-primary border-b-2 font-bold text-primary' : ''">Settings</a>
            <a href="#billing" @click.prevent="onNav('billing')" class="p-4" :class="hasNav('billing') ? 'border-primary border-b-2 font-bold text-primary' : ''">Billing</a>
        </nav>
        <div class="md:w-1/4"></div>
    </nav>
    <keep-alive>
        <div :is="component" v-bind="{'team': team }"></div>
    </keep-alive>
</div>
</template>

<script>
export default {
    props: {
        team: {
            type    : Object,
            required: true,
        }
    },
    data() {
        return {
            active: 'defaults'
        }
    },
    mounted() {
        window.addEventListener('popstate', (event) => {
            if (event.state) {
                this.setNav(event.state.url.slice(1)); // .slice(1) removes the leading '#'
            } else this.navigateUsingURL();
        });

        this.navigateUsingURL();
    },
    computed: {
        component() {
            switch (this.active) {
                case 'defaults':
                    return 'team-defaults';
                    break;

                case 'settings':
                    return 'team-settings';
                    break;
                
                case 'billing':
                    return 'team-billing';
                    break;
                
                default:
                    break;
            }
        }
    },
    methods: {
        navigateUsingURL() {
            if (!window.location.hash) {
                // Shows the default.
                this.onNav(this.active);
            } else {
                this.onNav(window.location.hash.slice(1)); // .slice(1) removes the leading '#'
            }
        },
        onNav(to) {
            var stateObject = {'url' : `#${to}`};

            if (window.location.hash && stateObject.url !== window.location.hash) {
                window.history.pushState(stateObject, document.title, window.location.pathname + stateObject.url);
            } else {
                window.history.replaceState(stateObject, document.title, window.location.pathname + stateObject.url);
            }

            this.setNav(to);
        },
        setNav(to) {
            this.active = to;
        },
        hasNav(active) {
            return this.active === active;
        }
    }
}
</script>